"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTable = void 0;
const lodash_1 = __importDefault(require("lodash"));
const throttle_1 = __importDefault(require("lodash/throttle"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../../Colors");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const common_1 = require("../../../../common");
const server_1 = require("../../../../server");
const account_1 = require("../../../base/account");
const popup_1 = require("../../../base/popup");
const ContentDropDown_1 = require("./ContentDropDown");
const DeleteItem_1 = require("./DeleteItem");
const DownloadQueue_1 = require("./DownloadQueue");
const ContentTableStyled = styled_components_1.default.div `
	flex: 1;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: ${props => (props.$isMobile ? '24px' : '12px')};

	${props => props.$isDesktop
    ? `
				height: ${props.$isReserve ? 'unset' : '100%'};
			  `
    : props.$isTablet &&
        `
				height: ${props.$isReserve ? 'unset' : '100%'};
			  `}

	${props => (props.$isTablet ? TabletStyles : props.$isMobile ? mobileStyles : DesktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	padding: 20px;
	
	.header {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.btn-container {
		justify-content: center;
		button {
			flex: 1;
		}
	}

	.contents-list-001 {
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex: 1;
		position: relative;
		height: unset;

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			align-self: stretch;
			flex: 1;
			position: relative;
			box-sizing: border-box;

			${props => props.$isReserve &&
    (0, styled_components_1.css) `
					// max-height: 600px;
					overflow: auto;
				`}
		}

		.table-header {
			padding-bottom: 14px;
		}

		.item {
			box-sizing: border-box;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px 0px 0px 0px;
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: row;
			gap: 4px;
			align-items: flex-start;
			justify-content: space-between;
			flex-shrink: 0;
			position: relative;
			width: 100%;

			color: var(--color-black, #101010);
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 12px);
			line-height: 150%;
			letter-spacing: var(--b3-letter-spacing, -0.02em);
			font-weight: var(--b3-font-weight, 400);

			.typeText {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: var(--b3-font-size, 12px);
				line-height: 150%;
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				font-weight: var(--b3-font-weight, 400);
			}

			.body-item {
				height: 100%;
				display: flex;
				justify-content: flex-start;
			}
		}
	}

	.contents-wrap {
		gap: 4px;
		display: flex;
		flex-direction: column;
		.title-text {
			font-size: 14px;
			font-weight: 700;
		}
	}

	.contents-item-wrap {
		color: var(--color-grey-l, #83868a);
		gap: 4px;
		display: flex;
	}

	.search-bar-big {
		padding: 10px;
		height: unset;
	}
`;
const TabletStyles = (0, styled_components_1.css) `
	.header {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-end;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.contents-list-001 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;
		height: unset;

		.scroll-content {
			${props => props.$isReserve &&
    (0, styled_components_1.css) `
					// max-height: 600px;
					overflow: auto;
				`}
		}
	}

	.table-header {
		${props => props.$isReserve
    ? (0, styled_components_1.css) `
						background: var(--color-silver, #f3f4f8);
						border-style: solid;
						border-color: var(--color-grey-w, #b6bac0);
						border-width: 1px 0px 0px 0px;
						padding: 10px 16px 10px 16px;
				  `
    : (0, styled_components_1.css) `
						background: var(--color-silver, #f3f4f8);
						border-radius: 40px;
						padding: 12px 20px 12px 20px;
						color: var(--color-grey, #666666);
						line-height: var(--b3-line-height, 32px);
				  `}

		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		color: var(--color-grey, #666666);
		text-align: center;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.body-item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.item {
		${props => props.$isReserve
    ? (0, styled_components_1.css) `
						padding: 12px 16px 12px 16px;
				  `
    : (0, styled_components_1.css) `
						padding: 24px 20px 24px 20px;
				  `}
		border-style: solid;
		border-color: var(--color-silver, #f3f4f8);
		border-width: 0px 0px 1px 0px;
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		p {
			color: var(--color-black, #101010);
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
`;
const DesktopStyles = (0, styled_components_1.css) `
	.header {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-end;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.contents-list-001 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;
		height: unset;

		.scroll-content {
			${props => props.$isReserve &&
    (0, styled_components_1.css) `
					// max-height: 600px;
					overflow: auto;
				`}
		}
	}

	.table-header {
		${props => props.$isReserve
    ? (0, styled_components_1.css) `
						background: var(--color-silver, #f3f4f8);
						border-style: solid;
						border-color: var(--color-grey-w, #b6bac0);
						border-width: 1px 0px 0px 0px;
						padding: 10px 16px 10px 16px;
				  `
    : (0, styled_components_1.css) `
						background: var(--color-silver, #f3f4f8);
						border-radius: 40px;
						padding: 6px 28px 6px 28px;
						color: var(--color-grey, #666666);
						line-height: var(--b3-line-height, 32px);
				  `}

		display: flex;
		flex-direction: row;
		gap: 24px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		text-align: center;
		font-size: var(--b3-font-size, 16px);
		font-weight: var(--b3-font-weight, 400);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.body-item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.item {
		${props => props.$isReserve
    ? (0, styled_components_1.css) `
						padding: 12px 16px 12px 16px;
				  `
    : (0, styled_components_1.css) `
						padding: 20px 28px 20px 28px;
				  `}
		border-style: solid;
		border-color: var(--color-silver, #f3f4f8);
		border-width: 0px 0px 1px 0px;

		display: flex;
		flex-direction: row;
		gap: 24px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		p {
			color: var(--color-black, #101010);
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
`;
const downloadQueue = new DownloadQueue_1.DownloadQueue();
exports.ContentTable = react_1.default.memo(({ typeList, menu, isReserve = false, defaultCheckList = [], setUpdateCheckList, isPopUp = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const isManager = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsManager)(state));
    const [page, setPage] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [count, setCount] = (0, react_1.useState)(10);
    const [checkList, setCheckList] = (0, react_1.useState)([]);
    const [searchOption, setSearchOption] = (0, react_1.useState)();
    const [filterMenu, setFilterMenu] = (0, react_1.useState)([]);
    const { data, refetch } = (0, server_1.useContents)({
        type: filterMenu,
        offset: page === 0 ? 0 : page * count,
        limit: count,
        ...(searchOption ? { ...searchOption } : {}),
        status: isPopUp ? ['converted'] : ['converted', 'uploaded'],
        orderby: ['creation_time desc'],
    });
    (0, react_1.useEffect)(() => {
        setPage(0);
    }, [filterMenu]);
    (0, react_1.useEffect)(() => {
        setFilterMenu(menu ? [menu] : typeList);
    }, [menu, typeList]);
    const refetchList = (0, throttle_1.default)(() => {
        refetch();
    }, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('REFRESH_CONTENTS', refetchList);
        APP.eventManager.subscribe('CONTENT_STATUS_ACCEPT', acceptContent);
        return () => {
            APP.eventManager.unsubscribe('REFRESH_CONTENTS', refetchList);
            APP.eventManager.unsubscribe('CONTENT_STATUS_ACCEPT', acceptContent);
        };
    }, []);
    const acceptContent = (data) => {
        const { contents_type } = data;
        if (contents_type === 'video') {
            refetchList();
        }
    };
    (0, react_1.useEffect)(() => {
        if (page !== 0)
            setPage(0);
    }, [searchOption]);
    (0, react_1.useEffect)(() => {
        if (filterMenu && filterMenu.length > 0)
            refetchList();
    }, [menu, page, searchOption, filterMenu]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, found_count, items } = data;
            const prevTestData = testData.filter(item => filterMenu.includes(item.type));
            // 기존의 페이지 관련 로직
            if (total_count > 0 && found_count === 0 && !isReserve) {
                const maxPage = Math.max(0, Math.ceil(total_count / 10) - 1);
                setPage(maxPage);
                return;
            }
            if (total_count > 0) {
                const list = items.map(i => ({
                    ...i,
                }));
                if (checkList.length > 0) {
                    const prevDataById = lodash_1.default.keyBy(prevTestData, 'id');
                    const newDataById = lodash_1.default.keyBy(list, 'id');
                    const mergedData = lodash_1.default.merge({}, prevDataById, newDataById);
                    const allItems = lodash_1.default.values(mergedData);
                    const checkedItems = allItems.filter(item => checkList.includes(item.id));
                    const notCheckedItems = allItems.filter(item => !checkList.includes(item.id));
                    setTestData([...checkedItems, ...notCheckedItems]);
                }
                else {
                    if (isReserve) {
                        const prevDataById = lodash_1.default.keyBy(prevTestData, 'id');
                        const newDataById = lodash_1.default.keyBy(list, 'id');
                        const mergedData = lodash_1.default.merge({}, prevDataById, newDataById);
                        setTestData(Object.values(mergedData));
                    }
                    else {
                        setTestData(items);
                    }
                }
                setTotalCount(total_count);
                return;
            }
        }
        // 데이터가 없는 경우의 초기화
        setTestData([]);
        setTotalCount(0);
    }, [data, checkList]); // filterMenu와 isReserve 의존성 추가
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = isMobile && isReserve
            ? []
            : [
                { title: 'fileName', space: 3, sort: false },
                ...(isPopUp ? [{ title: 'type', space: 1 }] : []),
                { title: 'size', space: 1 },
                ...(isReserve
                    ? []
                    : [
                        { title: 'author_name', space: 1, sort: false },
                        { title: 'registDate', space: 1, sort: false },
                        { title: 'status', space: 1, sort: false },
                        { title: 'etc', space: 1, sort: false },
                    ]),
            ];
        const tableReadDataKeys = [
            { title: 'name', space: isMobile ? 2 : 3 },
            ...(isPopUp ? [{ title: 'type', space: 1 }] : []),
            { title: 'size', space: isMobile ? 2 : 1 },
            ...(isReserve
                ? []
                : [
                    { title: 'author_name', space: 1 },
                    { title: 'creation_time', space: 1 },
                    { title: 'status', space: 1, sort: false },
                    { title: 'etc', space: 1 },
                ]),
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, []);
    const handlerMoreData = (page) => {
        if (isReserve)
            setPage(prevPage => prevPage + 1);
        else
            setPage(page);
    };
    // 상단 레이아웃 검색 조건을 위한 action
    const handlerFilterList = (filter) => {
        setSearchOption(filter);
    };
    const handlerDownload = async (item) => {
        if (item.id && item.name) {
            downloadQueue.enqueue(item);
        }
    };
    const getFileName = (name) => {
        let parts = name.split('.');
        // 마지막 요소(확장자) 제거
        if (parts.length > 1) {
            parts.pop();
        }
        // 다시 문자열로 결합
        return (name = parts.join('.'));
    };
    const renderTitle = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: "header" },
            isPopUp && (react_1.default.createElement(ContentDropDown_1.ContentDropDown, { typeList: typeList, setFilterMenu: setFilterMenu })),
            react_1.default.createElement(common_1.SearchBar, { className: `${!isMobile ? 'search-bar-qna' : 'search-bar-mobile'}`, filterData: "name", handlerFilterList: handlerFilterList })));
    }, [handlerFilterList]);
    const renderItem = (item, styles) => {
        return tableReadDataKeys.map((headItem, index) => isMobile &&
            (headItem.title === 'name' ||
                headItem.title === 'author_name' ||
                headItem.title === 'creation_time' ||
                headItem.title === 'status') ? null : (react_1.default.createElement("div", { key: index, className: "body-item", style: {
                flex: headItem.space,
                ...styles?.bodyItem,
                overflow: 'hidden',
                justifyContent: headItem.title === 'etc' && isMobile && 'flex-end',
            } }, headItem.title === 'etc' ? (item['status'] === 'converted' && (react_1.default.createElement("div", { style: { display: 'flex', gap: isMobile ? '20px' : '10px' } },
            isMobile && (react_1.default.createElement("p", { style: { width: 'max-content' } }, item['status'] === 'converted'
                ? t('common.complete')
                : t('supportRoom.uploading'))),
            isManager && (react_1.default.createElement(common_1.Button, { option: {
                    buttonAfterIcon: {
                        show: true,
                        name: 'file-down',
                        size: 20,
                        color: Colors_1.Colors.pur,
                    },
                }, onClick: () => handlerDownload(item) })),
            react_1.default.createElement(DeleteItem_1.DeleteContentItem, { menu: menu, deleteList: [item.id] })))) : headItem.title === 'size' ? (isMobile ? (react_1.default.createElement("div", { className: "contents-wrap" },
            react_1.default.createElement("p", { className: "title-text overText2" }, getFileName(item['name'])),
            react_1.default.createElement("div", { className: "contents-item-wrap" },
                react_1.default.createElement("p", { style: { color: Colors_1.Colors.black } }, item[headItem.title]),
                react_1.default.createElement("p", null, item['author_name']),
                react_1.default.createElement("p", null, (0, moment_1.default)(item['creation_time']).format('YYYY-MM-DD'))))) : (react_1.default.createElement("p", null, item[headItem.title]))) : headItem.title === 'status' ? (react_1.default.createElement("p", null, item[headItem.title] === 'uploaded'
            ? t('supportRoom.uploading')
            : t('common.complete'))) : headItem.title === 'type' ? (react_1.default.createElement("p", null, t(`supportRoom.${item[headItem.title]}`))) : (react_1.default.createElement("p", null, headItem.title === 'creation_time'
            ? (0, moment_1.default)(item[headItem.title]).format('YYYY-MM-DD')
            : headItem.title === 'name'
                ? getFileName(item[headItem.title])
                : item[headItem.title])))), []);
    };
    const renderEmpty = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "empty_data", style: { color: Colors_1.Colors.light_grey } },
        react_1.default.createElement(common_1.Icon, { icon: "detail-delete", size: isTablet || isMobile ? 36 : 60, fill: Colors_1.Colors.w_grey }),
        react_1.default.createElement("p", null, isReserve ? t(`supportRoom.contentsEmpty`) : t(`supportRoom.${menu}Empty`)))), [menu]);
    const closePopup = () => APP.eventManager.publish(popup_1.TOGGLE_POPUP, undefined);
    const submitContents = () => {
        if (testData
            .filter(item => checkList.includes(item.id))
            .filter(item => item.type === 'background').length > 1) {
            alert(t('error.onlyOneBackground'));
            return;
        }
        setUpdateCheckList && setUpdateCheckList(checkList);
        closePopup();
    };
    const renderGuidItem = (0, react_1.useMemo)(() => isMobile && isPopUp && react_1.default.createElement("div", null), [isMobile, isPopUp]);
    return (react_1.default.createElement(ContentTableStyled, { "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile, "$isReserve": isReserve, className: "content-table" },
        react_1.default.createElement(common_1.Table, { className: "contents-list-001", showIndex: isReserve || isMobile ? false : true, indexOrder: "desc", showCheckBox: isReserve ? true : false, 
            //isKeepChecked={isReserve ? true : false}
            isInfinite: isReserve ? true : false, defaultCheckList: defaultCheckList, page: page, showCount: count, data: testData, totalCount: totalCount, headTitleList: headTitleList, renderTitle: renderTitle, renderItem: renderItem, renderEmpty: totalCount <= 0 && renderEmpty, renderGuidItem: renderGuidItem, handlerCheckList: setCheckList, handlerMoreData: handlerMoreData, forceShowheader: (isTablet && totalCount <= 0) || (isMobile && !isReserve) ? false : true, padding: isReserve ? false : true }),
        isReserve && (react_1.default.createElement("div", { className: "btn-container" },
            react_1.default.createElement(common_1.Button, { text: "common.cancel", className: "btn_white xmd", onClick: closePopup }),
            react_1.default.createElement(common_1.Button, { text: "common.okay", className: "btn_default xmd", onClick: submitContents })))));
});
